import styles from "../../../styles/SelectPlano.module.css";
import { formatBRL, listaAssinaturaCiclo } from "../../utils/Utils";

const Step1 = ({ setPlanoSelecionado, setStep }) => {
    return (
        <div className={styles.container}>
            {listaAssinaturaCiclo.map((plano, key) => (
                <div key={key} className={styles.containerPlano}>
                    {plano.value === "YEARLY" && <p className={styles.maisEscolhido}>Mais escolhido</p>}

                    <div className={styles.boxPlano} style={{ borderColor: plano.value === "YEARLY" ? "#086006" : "#e4e4e4" }}>
                        <p className={styles.titulo}>{plano.label}</p>

                        <p className={styles.valor}>{formatBRL(plano.valor)}</p>

                        <p className={styles.periodo}>{plano.periodo}</p>

                        <div className={styles.boxExtras}>
                            {plano.conteudos.map((conteudo, index) => (
                                <p key={index} className={styles.extraItem}>
                                    <img src="/images/check.png" alt="Check" />

                                    {conteudo}
                                </p>
                            ))}
                        </div>

                        <button
                            type="button"
                            className={styles.botaoAdquirir}
                            onClick={() => {
                                setPlanoSelecionado(plano);
                                setStep((ant) => ant + 1);
                            }}
                        >
                            Adquirir plano
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Step1;